<div class="animation-infinite-wrapper">
    <div class="sms-gallery-list animation-infinite py-0 px-2">
        <p-carousel #pCarouselRef [value]="brands" [circular]="false" 
        [showIndicators]="false"
        [numVisible]="isMobile ? 2 : 5" [numScroll]="1"
        [showNavigators]="false" effect="fade">
            <ng-template let-brand pTemplate="body">
                <div styleClass="brand-view p-2 mx-4">
                    <div class="brand-logo-wrapper" [style]="brand?.scale || 'transform: scale(1);'">
                        <div class="always-full-width logo-alignment {{brand.class||'w-100'}}"
                            style="background-image: url({{firebaseBaseUrl}}{{brand.img}}?alt=media); "> </div>
                    </div>
                </div>
            </ng-template>
        </p-carousel>
    </div>
</div>

